import { render, staticRenderFns } from "./SelectInputResourceful.vue?vue&type=template&id=2713b0d9&scoped=true&"
import script from "./SelectInputResourceful.vue?vue&type=script&lang=js&"
export * from "./SelectInputResourceful.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputResourceful.vue?vue&type=style&index=0&id=2713b0d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713b0d9",
  null
  
)

export default component.exports